module.exports = __webpack_public_path__ + "media/images/cms/bg_nosettings-f4d7600ece924ed0ce986334efe293dd.png";